import { useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import CardHeader from "../CardHeader/CardHeader";
import CustomTextBox from "../CustomTextBox/CustomTextBox";
import CustomButton from "../CustomButton/CustomButton";
import theme from "../../theme/theme";
import { Auth } from "aws-amplify";
import CustomAlertLabel from "../CustomAlertLabel/CustomAlertLabel";
import CustomModal from "../CustomModal/CustomModal";
import { emailRegex } from "../../Regex";
import LoadingBar from "../LoadingBar/LoadingBar";

const BodyWrapper = styled.div`
  text-align: left;

  .inputBoxSection {
    margin-top: 7%;
  }

  .buttonContainer {
    text-align: right;
    margin-top: 7%;
  }

  .disclaimer {
    width: 100%;
    text-align: left;
    margin-top: 4%;
  }

  .linkButton {
    text-decoration: underline;
    color: ${theme.colors.primaryStrong};
    font-weight: 700;
    cursor: pointer;
  }
`;

const SendEmail = (props) => {
  const history = useHistory();

  const [customAlertMessage, setCustomAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(isLoading);
  const [mailId, setMailId] = useState("");
  const [customModalProps, setCustomModalProps] = useState({
    isVisible: false,
    headerMessage: "",
    subHeaderMessage: "",
    primaryButtonText: "",
  });

  const handleCustomModalOnClose = () => {
    setCustomModalProps((state) => ({
      ...state,
      isVisible: false,
    }));
  };

  const handleSignupClick = () => {
    history.push("/");
  };

  const handleLoginClick = () => {
    history.push("/login");
  };

  const handleCustomTextBoxOnBlur = (textBoxName, value) => {
    if (textBoxName === "mailId") {
      setMailId(value);
    }
  };

  const handleCustomTextBoxKeyPress = (event) => {
    if (event.key === "Enter") {
      sendEmailInstruction();
    }
  };

  const sendEmailInstruction = async () => {
    if (!mailId) {
      setCustomAlertMessage("All the fields are mandatory");
      return;
    }
    setCustomAlertMessage("");
    try {
      setIsLoading(true);
      await Auth.forgotPassword(mailId);
      props.mailSendSuccessfull(mailId);
    } catch (error) {
      //error -  UserNotConfirmedException: User is not confirmed.
      //error -  NotAuthorizedException: Incorrect username or password.
      if (error.name === "UserNotConfirmedException") {
        setIsLoading(false);
        setCustomModalProps((state) => ({
          ...state,
          isVisible: true,
          headerMessage:
            error.message || "Something went wrong please try again",
          subHeaderMessage: "Please verify your email",
          primaryButtonText: "Verify mail",
        }));
      } else if (error.name === "NotAuthorizedException") {
        setIsLoading(false);
        setCustomModalProps((state) => ({
          ...state,
          isVisible: true,
          headerMessage:
            error.message || "Something went wrong please try again",
          subHeaderMessage: "Username and password combination is wrong",
          primaryButtonText: "Ok",
        }));
      }
    }
  };

  const handleCustomModalPrimaryButtonClick = () => {};

  return (
    <BodyWrapper>
      {(isLoaded || isLoading) && (
        <LoadingBar isLoading={isLoading} setIsLoaded={setIsLoaded} />
      )}
      {customModalProps.isVisible && (
        <CustomModal
          onClose={handleCustomModalOnClose}
          headerMessage={customModalProps.headerMessage}
          subHeaderMessage={customModalProps.subHeaderMessage}
          primaryButtonText={customModalProps.primaryButtonText}
          onClick={handleCustomModalPrimaryButtonClick}
        />
      )}
      <CardHeader text={"Forgot your password?"} />
      <div className="inputBoxSection">
        <CustomTextBox
          placeholder="Email"
          errorMessage="Not a valid mail id"
          value={mailId}
          name="mailId"
          regexCode={emailRegex}
          onBlur={handleCustomTextBoxOnBlur}
          onKeyPress={handleCustomTextBoxKeyPress}
        />
      </div>
      <div className="buttonContainer">
        <CustomButton
          text={"Send Email instructions"}
          onClick={sendEmailInstruction}
        />
        <CustomAlertLabel message={customAlertMessage} />
      </div>
      <div className="disclaimer">
        Back to{" "}
        <span className="linkButton" onClick={handleLoginClick}>
          login
        </span>
      </div>
      <div className="disclaimer">
        Dont have an account?{" "}
        <span className="linkButton" onClick={handleSignupClick}>
          Sign Up here
        </span>
      </div>
    </BodyWrapper>
  );
};

export default SendEmail;
